import React from "react";
import { Table } from 'react-bootstrap';

const Exchange = () => {
    return (

        <div className="exchange">
            <Table striped="columns">
                <tbody>
                    <tr>
                        <td>교환/반품 배송비</td>
                        <td>
                            <ul>
                                <li>고객님의 단순변심으로 인해 교환/반품을 하실 경우에는 왕복 택배비 5,000원을 부담하셔야 합니다.</li>
                                <li>제품의 하자로 인해 반품/교환을 하실 경우에 택배비는 무료입니다.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>교환/반품 주소지</td>
                        <td>
                            <ul>
                                <li>경기도 이천시 마장면 덕평리 619번지 롯데로지스틱스 4층 캉골</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>교환/반품 불가사유</td>
                        <td className="last_info">
                            <ul>
                                <li>고객님의 단순변심(사이즈 부정확, 디자인 색상불만등)으로 인한 교환/반품은 상품을 수령하신날로부터 10일 이내에 가능합니다.</li>
                                <li>온라인에서 구매하신 제품은 오프라인 매장에서 교환 및 반품이 불가능합니다.</li>
                                <li>포장의 오리지날 택을 제거하였을 경우 교환/반품이 불가하오니 이 점 양해하여 주시기 바랍니다.</li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </Table>
        </div>
    )
}

export default Exchange;